import { Component } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router } from '@angular/router';
import {RestApiService} from '../../Services/rest-api-service'
import { ApiListDevPortal, ApiDevPortal } from 'src/app/Model/apilist-model';
import { environment } from 'src/environments/environment';
import { Subscription, SubscriptionList } from 'src/app/Model/product-model';
import { App, SmartApp } from 'src/app/Model/app-model';
import { AppListResponse } from 'src/app/Model/apilistresponse-model';

@Component({
  selector: 'app-subscriptionstatus',
  templateUrl: './subscriptionstatus.component.html'
})
export class SubscriptionStatusComponent{
  selectedApi:ApiDevPortal ;

  divRender: boolean;
  apis:Api[];
  cols: any[];
  publicListApi:ApiListDevPortal;
  publicApi:ApiDevPortal[];
  loadAppRequest:boolean=false;
  showTopDiv=false;

    //stat='default';
    role;
    fileName;
    roleDesc='Third party developer';
    devStatus_qu;
    payerStatus_qu;
    brokerStatus_qu;
    providerStatus_qu;

    displayPendingMSG=false;
    withoutQuesntionireMsg="Aetna Interoperability Team is currently reviewing questionnaire response of your previous application Subscription request";

    regionLabel;

    questionnaireTypeCode_n;
    constructor(private nodeService: NodeService,private router: Router,public restApi: RestApiService) {

    this.questionnaireTypeCode_n=localStorage.getItem("questionnaireTypeCode_n");
      this.regionLabel = environment.getEnvironment();
     //  this.stat=localStorage.getItem("stat");
       this.role=localStorage.getItem('roleValue');
       this.devStatus_qu=localStorage.getItem("devStatus_qu");
       this.payerStatus_qu =localStorage.getItem("payerStatus_qu");
       this.brokerStatus_qu=localStorage.getItem("brokerStatus_qu");
           
       this.providerStatus_qu=localStorage.getItem("providerStatus_qu");

       if(this.role=='1'){
        this.fileName='/payer/questionnaire';
        this.roleDesc='Payer';
     }else if(this.role=='0'){
       this.fileName='/third-party-developer/questionnaire';
       this.roleDesc='Third Party Developer';
     }else if(this.role=='3'){
      this.fileName='/provider/questionnaire';
      this.roleDesc='EHR';
    }else{
       this.fileName='/broker/questionnaire';
       this.roleDesc='Broker';
     }


       if(this.role=='1'  && this.payerStatus_qu=='NA'){

               this.questionnireSubmission("PAYER"); 
        
                localStorage.setItem("payerStatus_qu","0");
       

       }

       if(this.role=='0'  && this.devStatus_qu=='NA'){
         
         this.questionnireSubmission("THIRDDEV");
          localStorage.setItem("devStatus_qu","0");
      
       
       }


       if(this.role=='2'  && this.brokerStatus_qu=='NA'){
         
        this.questionnireSubmission("BROKER");
         localStorage.setItem("brokerStatus_qu","0");
     
      
      }

      if(this.role=='3'  && this.providerStatus_qu=='NA'){
         
        this.questionnireSubmission("PROVIDER");
         localStorage.setItem("providerStatus_qu","0");
     
      
      }


       if(this.role=='0'){
        if(this.devStatus_qu=='NA' || this.devStatus_qu=='0'){

          this.displayPendingMSG=true;
        }
      }

      if(this.role=='1'){
          if(this.payerStatus_qu=='NA'|| this.payerStatus_qu=='0'){

            this.displayPendingMSG=true;
          }
        }

        if(this.role=='2'){
          if(this.brokerStatus_qu=='NA'|| this.brokerStatus_qu=='0'){

            this.displayPendingMSG=true;
          }
        }


        if(this.role=='3'){
          if(this.providerStatus_qu=='NA'|| this.providerStatus_qu=='0'){

            this.displayPendingMSG=true;
          }
        }


          if(!this.displayPendingMSG && localStorage.getItem("single_email")=="1"){

             let bVeMail= localStorage.getItem("new_vettting_behaviour");

                if(bVeMail=="Y"){

                  this.loadAppList(this.role)
                  //this.sendEmailToBuinessForVetting();
                }else{
                  this.sendEmailToApproving(this.role);
                }
           
            localStorage.setItem("single_email","0");

            localStorage.setItem("new_vettting_behaviour","NA");
            
          }



         if(!this.displayPendingMSG){

             let lowerLevelApproval=  localStorage.getItem("Lower_value_approval");
             
             if(lowerLevelApproval=='A'){

              this.withoutQuesntionireMsg="Aetna Interoperability Team will review and approve your Subscription request.";


             }else{
              this.withoutQuesntionireMsg="Aetna Interoperability Team is currently reviewing questionnaire response of your previous application Subscription request.";

             }

         }




     }

    

     questionnireSubmission(quType){
      //console.log(this.userValues);
    
      let fullName=localStorage.getItem("firstName")+" "+localStorage.getItem("lastName");
    
      let securityReview:boolean=false;
      let userConstent:boolean=false;
      let regReview:boolean=false;
    
      
     
      const requestJSON={"orgName": "NA",
                         "emailIdentifier": localStorage.getItem("email_ID"),
                         "appName":"NA",
                         "orgCountryCode": "NA", "roleName": "NA",
                         "phiDataText": "NA", "domainName": "NA",
                         "securityPracticesIndicator": securityReview, 
                         "regularlyReviewedIndicator": regReview, "userConsentIndicator": userConstent ,"deletionFlagCode":false,"firstName":localStorage.getItem("firstName"),"lastName":localStorage.getItem("lastName"),"status":"0","lastUpdateUserIdentifier":localStorage.getItem("email_ID"),"questionnaireTypeCode":quType,"questionnaireStatusText":"0","payerDataText":"NA","parentOrgName":"NA","registrantName":"NA"};
      console.log(requestJSON);
      this.restApi.ThirdPartyDevQuestionnaire_PostRequest(requestJSON).subscribe(
        (data)=>{
        
       
    
        },
        (error)=>{
      
          
      })
        
    }
    


    ngOnInit() {
      this.loadAppRequest=true;
       this.cols = [
            { field: 'apiName',header: 'API Name'}, { field: 'id', header: 'API ID' },];
      // this.loadPublicApis();
      }


  loadPublicApis() {
    return this.restApi.getPublicApis().subscribe((data: {}) => {
   
      this.publicListApi=data as ApiListDevPortal;
       this.publicApi=this.publicListApi.publicAPIView;
       this.loadAppRequest=false; 
    },(error)=>{
      this.loadAppRequest=false;
      // console.log(error);
    })
  }


 viewSwagger(){
    window.open("/swagger/"+this.selectedApi.id, "_blank");
  }

  onRowSelect() {
  console.log("veeeeeeeeeeeeeeee")  
  this.showTopDiv=true;
   //window.location.hash='#details';
   document.querySelector('#details').scrollIntoView({ behavior: 'smooth', block: 'start'});
  }


     
  sendEmailToApproving(roleEmail){


    switch (roleEmail) {
      case "1":
        this.roleLabelForEmail='Payer';
        this.reportURL=environment.payer_report_url();
        break;
      case "2":
        this.roleLabelForEmail='Broker';
        this.reportURL=environment.broker_report_url();
        break;
      case "3":
        this.roleLabelForEmail='Provider EHR';
        this.reportURL=environment.provider_report_url();
        break;
      default:
        this.roleLabelForEmail='Third-Party';
        this.reportURL=environment.dev_report_url();
        break;
    }
   
    let accessEnv=localStorage.getItem("access_env");

    if(accessEnv!=null){

      accessEnv = accessEnv.charAt(0).toUpperCase() + accessEnv.slice(1);
    }

   let approveLimk="user-access-request/"+localStorage.getItem("email_ID");

     if(this.regionLabel=='qa'){
      approveLimk=  "https://apiconboardingportal-oci-dev.apps.devocp-int-aetw.aetna.com/user-access-request/"+localStorage.getItem("email_ID");
     }else{
     
      approveLimk=  "https://apiconboardingportal-oci-qa.apps.qaocp-int-aetm.aetna.com/user-access-request/"+localStorage.getItem("email_ID");
     }




   //console.log("sending emails-------------------------------"+environment.getEmailDL())
    let htmlBodyB="<style>table, th, td {border: 1px solid black;border-collapse: collapse;}th, td {padding: 5px;}th {text-align: left;}</style><br><p>Dear Interoperability Team,<br/><br>The below user has submitted another access request.<br>Please use the below Quickbase link to initiate the vetting process. <br/><br/> Registered email ID : "+localStorage.getItem("email_ID")+"</p><br><table style='width:80%'><tr><th>Registrant Name</th><th>Environment</th><th>Role</th></tr><tr><td>"+localStorage.getItem("firstName")+" "+localStorage.getItem("lastName")+"</td><td>"+accessEnv+"</td><td>"+this.roleLabelForEmail+"</td></tr></table><br>"+this.reportURL+localStorage.getItem("email_ID");
    let toB=environment.getEmailDL();
    let fromB="APICDevportal@AETNA.com";
    let subjectB="Additional Access Request Received for "+this.roleLabelForEmail;
    let request={from:fromB,to:toB,htmlBody:htmlBodyB,subject:subjectB,bcc:'NA',cc:'NA'};
      return this.restApi.emailTrigger(request).subscribe((data: {}) => {
       
      },(error)=>{
        
       //  console.log(error);
      })

  }


  sendEmailToBuinessForVetting(){

    let approveLimk="user-access-request/"+localStorage.getItem("email_ID");

    if(this.regionLabel=='qa'){
     approveLimk=  "https://apiconboardingportal-oci-dev.apps.devocp-int-aetw.aetna.com/user-access-request/"+localStorage.getItem("email_ID");
    }else{
    
     approveLimk=  "https://apiconboardingportal-oci-qa.apps.qaocp-int-aetm.aetna.com/user-access-request/"+localStorage.getItem("email_ID");
    }

    console.log("sending emails-------------------------------"+environment.getEmailDL())
    let htmlBodyB="<style>table, th, td {border: 1px solid black;border-collapse: collapse;}th, td {padding: 5px;}th {text-align: left;}</style><br><p>Dear Interoperability Team,<br/><br/>The below Sandbox approved user has requested to create a Production application.<br><br>Please use the below Quickbase link to view the request and perform appropriate behavior vetting.</p><table style='width:100%'><tr><th>Registrant Name</th><th>Registrant Email Address</th><th>Sandbox Application Name(s)</th><th>Product(s) Subscribed</th></tr><tr><td>"+localStorage.getItem("firstName")+" "+localStorage.getItem("lastName")+"</td><td> <u>"+localStorage.getItem("email_ID")+"</u> </td><td>"+localStorage.getItem("email_display_app_name")+"</td><td>"+localStorage.getItem("email_display_sub_name")+"</td></tr></table><br>"+this.reportURL+localStorage.getItem("email_ID");
    let toB=environment.getEmailDL();
    let fromB="APICDevportal@AETNA.com";
    let subjectB="Behavior Vetting Required for "+this.roleLabelForEmail+"("+this.regionLabel+")";
    let request={from:fromB,to:toB,htmlBody:htmlBodyB,subject:subjectB,bcc:'NA',cc:'NA'};
      return this.restApi.emailTrigger(request).subscribe((data: {}) => {
       
      },(error)=>{
        
       //  console.log(error);
      })

  }



  appList;
  roleLabelForEmail;
  reportURL;
  loadAppList(roleEmail) {

    switch (roleEmail) {
      case "1":
        this.roleLabelForEmail='Payer';
        this.reportURL=environment.payer_report_url();
        break;
      case "2":
        this.roleLabelForEmail='Broker';
        this.reportURL=environment.broker_report_url();
        break;
      case "3":
        this.roleLabelForEmail='Provider EHR';
        this.reportURL=environment.provider_report_url();
        break;
      default:
        this.roleLabelForEmail='Third-Party';
        this.reportURL=environment.dev_report_url();
        break;
    }
    
   


   localStorage.removeItem("email_display_app_name");
   localStorage.removeItem("email_display_sub_name");
    return this.restApi.getAppList().subscribe(async (data: {}) => {
     
      this.appList=data as AppListResponse;
     // console.log("App List"+this.appList.status); 

      for(let myapp of this.appList.appListView){

        console.log("my app env "+myapp.path)
        console.log("roleEmail "+roleEmail)
        
        if(myapp.path=='sandbox'){
          localStorage.setItem("path","sandbox");
          await this.loadSmartAppFlag(myapp,roleEmail);
         // await this.mySubscriptionForAnApp(myapp.appID);
        }
      }

   let emailApp=   localStorage.getItem("email_display_app_name");

   if(emailApp!=null){
    emailApp=this.removeLastComma(emailApp);
   }
   localStorage.setItem("email_display_app_name",emailApp);
   let emailSub=   localStorage.getItem("email_display_sub_name");

   if(emailSub!=null){
     emailSub=this.removeLastComma(emailSub);
   }
   localStorage.setItem("email_display_sub_name",emailSub);
   this.sendEmailToBuinessForVetting();
    
    },(error)=>{
    })
  }
 

removeLastComma(str){
  

  if (str.charAt(str.length - 1) === ',') {
    str = str.substring(0, str.length - 1);
  }

  return str;
}


async  loadSmartAppFlag(smartApp:App,roleEmail){



    let smartAppId=smartApp.appID;

    if(smartApp.legacyInd=='y'){

     smartAppId=smartApp.v5Id;
    }


   

     return this.restApi.getSmartAppFlag_promise(smartAppId).then(async (data: {}) => {

 //console.log("samrt app "+data.payerFlag)
 

   let  ResponseApp= data as SmartApp;

    smartApp.roleValue= ResponseApp.payerFlag;

    if(smartApp.roleValue==roleEmail){
    
      let appDisplay=localStorage.getItem("email_display_app_name");
      
       if(appDisplay==null){
        appDisplay=smartApp.appName+",";
       }else{
        appDisplay=appDisplay+smartApp.appName+",";
       }
    


      localStorage.setItem("email_display_app_name",appDisplay)

      await this.mySubscriptionForAnApp(smartApp.appID);
   
    }


   


     

},(error)=>{

     

})

}
subscriptionListForAnApp:SubscriptionList;
subscriptionForAnApp:Subscription[];
async mySubscriptionForAnApp(appID){
  // console.log("here we are")
 
 
  return this.restApi.mySubscriptionForAnApp_promise(appID).then((data: {}) => {
 
    this.subscriptionListForAnApp=data as SubscriptionList;
    this.subscriptionForAnApp=this.subscriptionListForAnApp.subsApiVO;

 
 
    for(const sub of this.subscriptionForAnApp){
       
      let subDisplay=localStorage.getItem("email_display_sub_name");
      
      if(subDisplay==null){
        subDisplay=sub.productName+",";
      }else{
        subDisplay=subDisplay+sub.productName+",";
      }
   


     localStorage.setItem("email_display_sub_name",subDisplay)

    
     }//end of for

   
  
   },(error)=>{

   })
 }




  }

